var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPlaceholderDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1D1E21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 20C8 13.383 13.383 8 20 8C26.617 8 32 13.383 32 20C32 26.617 26.617 32 20 32C13.383 32 8 26.617 8 20ZM22 24C24.198 24 26.034 25.431 26.698 27.404C28.72 25.573 30 22.936 30 20C30 14.486 25.514 10 20 10C14.486 10 10 14.486 10 20C10 22.937 11.281 25.574 13.304 27.405C13.968 25.432 15.802 24 18 24H22ZM16 17C16 14.791 17.791 13 20 13C22.209 13 24 14.791 24 17V18C24 20.209 22.209 22 20 22C17.791 22 16 20.209 16 18V17Z",
    fill: "#393C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholderDark);
export default __webpack_public_path__ + "static/media/avatar_placeholder_dark.7e44b20edfd906f4e22e94ab62a1d59f.svg";
export { ForwardRef as ReactComponent };